interface Props {
  materiales: string
  alCambiarMateriales: (v: string) => void
  instalacion: string
  alCambiarInstalacion: (v: string) => void
  /** La partida esta quitada: el campo se desactiva (no se puede fijar el valor de algo que no va). */
  materialesQuitados: boolean
  instalacionQuitada: boolean
  placeholderInstalacion: string
}

/** Materiales electricos e instalacion a mano: lo escrito es su COSTO; lleva la utilidad como el resto (y 15 % de IVA). */
export function CamposManuales(p: Props) {
  return (
    <>
      <label>
        Materiales eléctricos (USD)
        <input
          value={p.materiales}
          onChange={(e) => p.alCambiarMateriales(e.target.value)}
          inputMode="decimal"
          disabled={p.materialesQuitados}
          placeholder={p.materialesQuitados ? 'Partida quitada' : 'Vacío = valor del catálogo'}
        />
        <small className="ayuda">Si lo escribes, es tu costo: se le suma la utilidad de abajo, más 15 % de IVA.</small>
      </label>
      <label>
        Instalación (USD)
        <input
          value={p.instalacion}
          onChange={(e) => p.alCambiarInstalacion(e.target.value)}
          inputMode="decimal"
          disabled={p.instalacionQuitada}
          placeholder={p.instalacionQuitada ? 'Partida quitada' : p.placeholderInstalacion}
        />
        <small className="ayuda">Si lo escribes, es tu costo: se le suma la utilidad de abajo, más 15 % de IVA.</small>
      </label>
    </>
  )
}
